// extracted by mini-css-extract-plugin
export default {"root":"MainWrapper_root__Czy97","content":"MainWrapper_content__h8Y0q"};